/* skeleton.tsx generated by @compiled/babel-plugin v3.0.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDaaQb%7Bborder-radius%3Avar(--ds-radius-full%2C50%25)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2V7sgO2M4S%7Bborder-width%3Avar(--ds-border-width-selected%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3hxITi6wH8%7Bborder-style%3Asolid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3vBAKHjOvk%7Bborder-color%3Atransparent%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbvbI6%7Bdisplay%3Ainline-block%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXruNaal%7Bbackground-color%3Avar(--avatar-skeleton-background-color)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1YKVNs4ERJ%7Bopacity%3A.15%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvD0O7w%7Bborder-radius%3Avar(--ds-radius-tile%2C25%25)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1uo2ZfTcEg%7Bclip-path%3Apolygon(45%25%201.33975%25%2C46.5798%25%20.60307%25%2C48.26352%25%20.15192%25%2C50%25%200%2C51.73648%25%20.15192%25%2C53.4202%25%20.60307%25%2C55%25%201.33975%25%2C89.64102%25%2021.33975%25%2C91.06889%25%2022.33956%25%2C92.30146%25%2023.57212%25%2C93.30127%25%2025%25%2C94.03794%25%2026.5798%25%2C94.48909%25%2028.26352%25%2C94.64102%25%2030%25%2C94.64102%25%2070%25%2C94.48909%25%2071.73648%25%2C94.03794%25%2073.4202%25%2C93.30127%25%2075%25%2C92.30146%25%2076.42788%25%2C91.06889%25%2077.66044%25%2C89.64102%25%2078.66025%25%2C55%25%2098.66025%25%2C53.4202%25%2099.39693%25%2C51.73648%25%2099.84808%25%2C50%25%20100%25%2C48.26352%25%2099.84808%25%2C46.5798%25%2099.39693%25%2C45%25%2098.66025%25%2C10.35898%25%2078.66025%25%2C8.93111%25%2077.66044%25%2C7.69854%25%2076.42788%25%2C6.69873%25%2075%25%2C5.96206%25%2073.4202%25%2C5.51091%25%2071.73648%25%2C5.35898%25%2070%25%2C5.35898%25%2030%25%2C5.51091%25%2028.26352%25%2C5.96206%25%2026.5798%25%2C6.69873%25%2025%25%2C7.69854%25%2023.57212%25%2C8.93111%25%2022.33956%25%2C10.35898%25%2021.33975%25)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1YKVNsy8LG%7Bopacity%3A.3%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02ey7F%7Bwidth%3A1pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0Vey7F%7Bheight%3A1pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02SPN1%7Bwidth%3A20px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VSPN1%7Bheight%3A20px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02oWWg%7Bwidth%3A24px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VoWWg%7Bheight%3A24px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02Uofl%7Bwidth%3A2pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VUofl%7Bheight%3A2pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02UF4f%7Bwidth%3A40px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VUF4f%7Bheight%3A40px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02JgOI%7Bwidth%3A6pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VJgOI%7Bheight%3A6pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02NNui%7Bwidth%3A8pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VNNui%7Bheight%3A8pc%7D");
import { type CSSProperties, type FC } from 'react';
import { type AppearanceType, type SizeType } from './types';
export interface SkeletonProps {
  /**
   * Indicates the shape of the avatar skeleton. Most avatars are circular, but square avatars can be used for container objects.
   */
  appearance?: AppearanceType;
  /**
   * Color of the skeleton. By default, it will inherit the current text color.
   */
  color?: string;
  /**
   * Defines the size of the avatar skeleton.
   */
  size?: SizeType;
  /**
   * Defines the opacity of the avatar skeleton. Use `weight="normal"` for the default opacity, or `weight="strong"` for a bolder opacity.
   */
  weight?: 'normal' | 'strong';
}
const bgColorCssVar = '--avatar-skeleton-background-color';
const styles = {
  root: "_0bjKvDaaQb _2V7sgO2M4S _3hxITi6wH8 _3vBAKHjOvk _3iDTPbvbI6 _0KLXruNaal _1YKVNs4ERJ",
  square: "_0bjKvD0O7w",
  hexagon: "_1uo2ZfTcEg",
  strongOpacity: "_1YKVNsy8LG"
};
const sizeStyles = {
  xxsmall: "_39xV02ey7F _0jFU0Vey7F",
  xsmall: "_39xV02ey7F _0jFU0Vey7F",
  UNSAFE_xsmall: "_39xV02SPN1 _0jFU0VSPN1",
  small: "_39xV02oWWg _0jFU0VoWWg",
  medium: "_39xV02Uofl _0jFU0VUofl",
  large: "_39xV02UF4f _0jFU0VUF4f",
  xlarge: "_39xV02JgOI _0jFU0VJgOI",
  xxlarge: "_39xV02NNui _0jFU0VNNui"
};

/**
 * __Skeleton__
 *
 * A skeleton is the loading state for the avatar component.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-skeleton/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-skeleton/code)
 */
const Skeleton: FC<SkeletonProps> = ({
  size,
  appearance = 'circle',
  color,
  weight
}: SkeletonProps) => {
  const avatarSize = size ?? 'medium';
  return <div style={({
    [bgColorCssVar]: color ?? 'currentColor'
  } as CSSProperties)} className={ax([styles.root, sizeStyles[avatarSize], appearance === 'square' && styles.square, appearance === 'hexagon' && styles.hexagon, weight === 'strong' && styles.strongOpacity])} />;
};
export default Skeleton;